/*
 * Product-detail image load polish.
 *
 * Shows a shimmer placeholder over each gallery image while it loads, then —
 * after a short delay so the swap isn't jarring — fades the image in (a plain
 * opacity fade, no slide/bounce). Purely progressive: the CSS only hides the
 * image once this script adds `.media-loading`, so images still render normally
 * if the script never runs.
 */
(function () {
  var SHOW_DELAY_MS = 180; // slight pause before revealing, so shimmer->image is smooth
  var FADE_MS = 500; // keep in sync with the CSS opacity transition

  function bind(container) {
    try {
      var media = container.querySelector('.product__media');
      var img = media && media.querySelector('img');
      if (!media || !img || media.dataset.fadeBound) return;
      media.dataset.fadeBound = '1';
      media.classList.add('media-loading');

      var revealed = false;
      function reveal() {
        if (revealed) return;
        revealed = true;
        setTimeout(function () {
          media.classList.add('media-loaded');
          // Drop the shimmer once the image is opaque (also avoids it showing
          // through transparent PNGs).
          setTimeout(function () { media.classList.remove('media-loading'); }, FADE_MS);
        }, SHOW_DELAY_MS);
      }

      if (img.complete && img.naturalWidth > 0) {
        reveal();
      } else {
        img.addEventListener('load', reveal, { once: true });
        // On error, don't leave the image invisible behind a shimmer forever.
        img.addEventListener('error', function () {
          revealed = true;
          media.classList.remove('media-loading');
          media.classList.add('media-loaded');
        }, { once: true });
      }
    } catch (e) {
      // Never let a hiccup leave the gallery hidden.
      container.querySelectorAll('.product__media').forEach(function (m) {
        m.classList.remove('media-loading');
      });
    }
  }

  function init() {
    var containers = document.querySelectorAll(
      '.product__media-list .product-media-container.media-type-image'
    );
    for (var i = 0; i < containers.length; i++) bind(containers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
